//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* eslint-disable */
// ReSharper disable InconsistentNaming
import moment from 'moment';
import { BaseHttpClient } from './base-http-client';
export class DoctorsDashboardActionRequiredAlertsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getActionRequiredAlerts(patientId, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/action-required-alerts";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetActionRequiredAlerts(_response);
        });
    }
    processGetActionRequiredAlerts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListActionRequiredAlertsResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getActionRequiredAlertTypes(version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/action-required-alerts/types";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetActionRequiredAlertTypes(_response);
        });
    }
    processGetActionRequiredAlertTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ActionRequiredAlertType.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCarePractitionerActions(version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/action-required-alerts/actions";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetCarePractitionerActions(_response);
        });
    }
    processGetCarePractitionerActions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CarePractitionerActionDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardCareNoteHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param generateReportForMonth (optional)
     * @param body (optional)
     * @return Success
     */
    addPatientCareNote(patientId, generateReportForMonth, version, body) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/care-notes?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (generateReportForMonth === null)
            throw new globalThis.Error("The parameter 'generateReportForMonth' cannot be null.");
        else if (generateReportForMonth !== undefined)
            url_ += "generateReportForMonth=" + encodeURIComponent(generateReportForMonth ? "" + generateReportForMonth.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddPatientCareNote(_response);
        });
    }
    processAddPatientCareNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListCareNotesResultEntry.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param take (optional)
     * @param lastRowMarker (optional) Specify that field, if next portion after specific row is needed.
     * @param notEarlierThan (optional)
     * @param notLaterThan (optional)
     * @return Success
     */
    searchPatientCareNotes(patientId, take, lastRowMarker, notEarlierThan, notLaterThan, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/care-notes?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (lastRowMarker !== undefined && lastRowMarker !== null)
            url_ += "LastRowMarker=" + encodeURIComponent("" + lastRowMarker) + "&";
        if (notEarlierThan !== undefined && notEarlierThan !== null)
            url_ += "NotEarlierThan=" + encodeURIComponent(notEarlierThan ? "" + notEarlierThan.toISOString() : "") + "&";
        if (notLaterThan !== undefined && notLaterThan !== null)
            url_ += "NotLaterThan=" + encodeURIComponent(notLaterThan ? "" + notLaterThan.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSearchPatientCareNotes(_response);
        });
    }
    processSearchPatientCareNotes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ListCareNotesResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardDailyReportsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param reportName (optional)
     * @return Success
     */
    getPatientActivityLogReport(patientId, reportName, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/reports/daily?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (reportName !== undefined && reportName !== null)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientActivityLogReport(_response);
        });
    }
    processGetPatientActivityLogReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardDashboardUserProfileHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getDashboardUserProfile(version) {
        let url_ = this.baseUrl + "/api/v{version}/profile/me";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetDashboardUserProfile(_response);
        });
    }
    processGetDashboardUserProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDashboardUserProfileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardMonthlyReportsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Retrieve monthly activity log report for specified patient by report's name.
     * @param patientId Patient id.
     * @param reportName (optional) Report name.
     * @return Success
     */
    downloadActivityLogReport(patientId, reportName, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/reports/monthly/activity-log?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (reportName !== undefined && reportName !== null)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDownloadActivityLogReport(_response);
        });
    }
    processDownloadActivityLogReport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Returns all reports names for the specified patient.
     * @param count (optional)
     * @param nextMarker (optional)
     * @return Success
     */
    getPatientMonthlyReportsList(patientId, count, nextMarker, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/reports/monthly/list?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        if (nextMarker !== undefined && nextMarker !== null)
            url_ += "NextMarker=" + encodeURIComponent("" + nextMarker) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientMonthlyReportsList(_response);
        });
    }
    processGetPatientMonthlyReportsList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientReportsListResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardOrganizationHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * List organizations
     * @return Success
     */
    getOrganizationsList(version) {
        let url_ = this.baseUrl + "/api/v{version}/organizations";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetOrganizationsList(_response);
        });
    }
    processGetOrganizationsList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationOutputDtoPagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return throwException("Success", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardOrganizationReportsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Returns zipped reports for all users of the organization that care practitioner belongs to, in a month of year.
     * @param year (optional) Required year.
     * @param month (optional) Required month.
     * @return Success
     */
    downloadZippedActivityLogReports(year, month, version) {
        let url_ = this.baseUrl + "/api/v{version}/reports/monthly/reports/monthly/activity-log?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processDownloadZippedActivityLogReports(_response);
        });
    }
    processDownloadZippedActivityLogReports(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardPatientInsightsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * Returns patient insight images for the given patient within the specified date range.
    Requires either all-organization access or the requesting user to be in the same organization as the patient.
     * @param patientId The patient whose insights are being requested.
     * @param date (optional) Target date for patient insights (no time component)
     * @param numberOfImages (optional) Maximum number of patient insights to return
     * @param descending (optional) Search and sort direction for the results
     * @param generatedBefore (optional)
     * @return Success
     */
    getPatientInsights(patientId, date, numberOfImages, descending, generatedBefore, version) {
        let url_ = this.baseUrl + "/api/v{version}/insights/{patientId}?";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (date !== undefined && date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (numberOfImages !== undefined && numberOfImages !== null)
            url_ += "NumberOfImages=" + encodeURIComponent("" + numberOfImages) + "&";
        if (descending !== undefined && descending !== null)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (generatedBefore !== undefined && generatedBefore !== null)
            url_ += "GeneratedBefore=" + encodeURIComponent("" + generatedBefore) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientInsights(_response);
        });
    }
    processGetPatientInsights(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PatientInsightsResponseModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                return throwException("Forbidden", status, _responseText, _headers);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status === 502) {
            return response.text().then((_responseText) => {
                return throwException("Server Error", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardPatientScratchPadHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getPatientScratchPadNote(patientId, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/scratch-pad";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientScratchPadNote(_response);
        });
    }
    processGetPatientScratchPadNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetScratchPadNoteResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    upsertPatientScratchPadNote(version, patientId, body) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/scratch-pad";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processUpsertPatientScratchPadNote(_response);
        });
    }
    processUpsertPatientScratchPadNote(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpsertScratchPadNoteResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardPatientStatisticsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param startDate Monitoring cycle in UTC
     * @return Success
     */
    getPatientSummaryStatistics(patientId, startDate, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/statistics/{startDate}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientSummaryStatistics(_response);
        });
    }
    processGetPatientSummaryStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PatientOverallSummary.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardPatientStepCountHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param startDate Monitoring cycle in UTC
     * @return Success
     */
    getPatientStepCountSummary(patientId, startDate, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/step-counts/{startDate}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientStepCountSummary(_response);
        });
    }
    processGetPatientStepCountSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PatientStepCountsSummary.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardPatientTemperatureStatsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param startDate Monitoring cycle in UTC
     * @return Success
     */
    getPatientTemperatureStatistics(patientId, startDate, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}/statistics/temperature/{startDate}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientTemperatureStatistics(_response);
        });
    }
    processGetPatientTemperatureStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PatientTemperatureResultModel.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class DoctorsDashboardPatientsHttpClient extends BaseHttpClient {
    constructor(baseUrl, http) {
        super();
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param term (optional)
     * @param orderBy_OrderByAsc (optional)
     * @param orderBy_OrderBy (optional)
     * @param priorityStatus (optional)
     * @param organizationId (optional)
     * @param offset (optional)
     * @param count (optional)
     * @return Success
     */
    getPatientsList(term, patientsType, filterBy, orderBy_OrderByAsc, orderBy_OrderBy, priorityStatus, organizationId, offset, count, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients?";
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (patientsType === undefined || patientsType === null)
            throw new globalThis.Error("The parameter 'patientsType' must be defined and cannot be null.");
        else
            url_ += "PatientsType=" + encodeURIComponent("" + patientsType) + "&";
        if (filterBy === undefined || filterBy === null)
            throw new globalThis.Error("The parameter 'filterBy' must be defined and cannot be null.");
        else
            url_ += "FilterBy=" + encodeURIComponent("" + filterBy) + "&";
        if (orderBy_OrderByAsc === null)
            throw new globalThis.Error("The parameter 'orderBy_OrderByAsc' cannot be null.");
        else if (orderBy_OrderByAsc !== undefined)
            url_ += "OrderBy.OrderByAsc=" + encodeURIComponent("" + orderBy_OrderByAsc) + "&";
        if (orderBy_OrderBy === null)
            throw new globalThis.Error("The parameter 'orderBy_OrderBy' cannot be null.");
        else if (orderBy_OrderBy !== undefined)
            url_ += "OrderBy.OrderBy=" + encodeURIComponent("" + orderBy_OrderBy) + "&";
        if (priorityStatus === null)
            throw new globalThis.Error("The parameter 'priorityStatus' cannot be null.");
        else if (priorityStatus !== undefined)
            url_ += "PriorityStatus=" + encodeURIComponent("" + priorityStatus) + "&";
        if (organizationId !== undefined && organizationId !== null)
            url_ += "OrganizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientsList(_response);
        });
    }
    processGetPatientsList(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientsListResponsePagingResult.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getPatientInformation(patientId, version) {
        let url_ = this.baseUrl + "/api/v{version}/patients/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processGetPatientInformation(_response);
        });
    }
    processGetPatientInformation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPatientInformationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = OperationError.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401 = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = OperationError.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = OperationError.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = OperationError.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = OperationError.fromJS(resultData409);
                return throwException("Conflict", status, _responseText, _headers, result409);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export var OperationResultCode;
(function (OperationResultCode) {
    OperationResultCode["UnknownError"] = "UnknownError";
    OperationResultCode["Successfully"] = "Successfully";
    OperationResultCode["Skipped"] = "Skipped";
    OperationResultCode["NoContent"] = "NoContent";
    OperationResultCode["InvalidData"] = "InvalidData";
    OperationResultCode["InvalidFilter"] = "InvalidFilter";
    OperationResultCode["PatientIdentifierIsExist"] = "PatientIdentifierIsExist";
    OperationResultCode["AuthorizationRequired"] = "AuthorizationRequired";
    OperationResultCode["InvalidAuthorizationToken"] = "InvalidAuthorizationToken";
    OperationResultCode["InvalidB2CObjectId"] = "InvalidB2CObjectId";
    OperationResultCode["Unauthorized"] = "Unauthorized";
    OperationResultCode["MethodNotAvailableToCall"] = "MethodNotAvailableToCall";
    OperationResultCode["EmailIsTaken"] = "EmailIsTaken";
    OperationResultCode["DataBaseError"] = "DataBaseError";
    OperationResultCode["StorageException"] = "StorageException";
    OperationResultCode["ExceptionError"] = "ExceptionError";
    OperationResultCode["NetworkError"] = "NetworkError";
    OperationResultCode["StorageEntityHasInitializationError"] = "StorageEntityHasInitializationError";
    OperationResultCode["IOError"] = "IOError";
    OperationResultCode["NotImplemented"] = "NotImplemented";
    OperationResultCode["NotSupported"] = "NotSupported";
    OperationResultCode["AzureTableAccessError"] = "AzureTableAccessError";
    OperationResultCode["PatientNotFound"] = "PatientNotFound";
    OperationResultCode["PatientNotActive"] = "PatientNotActive";
    OperationResultCode["PatientsNotFound"] = "PatientsNotFound";
    OperationResultCode["OrganizationNotFound"] = "OrganizationNotFound";
    OperationResultCode["PatientDeleted"] = "PatientDeleted";
    OperationResultCode["ActionRequiredAlertDoesntBelongToPatient"] = "ActionRequiredAlertDoesntBelongToPatient";
    OperationResultCode["OrganizationNameIsExist"] = "OrganizationNameIsExist";
    OperationResultCode["ActivityLogReportNotFound"] = "ActivityLogReportNotFound";
    OperationResultCode["MobileUserForPatientNotFound"] = "MobileUserForPatientNotFound";
    OperationResultCode["MobileUserNotFound"] = "MobileUserNotFound";
    OperationResultCode["UserAlertNotFound"] = "UserAlertNotFound";
    OperationResultCode["CarePractitionerReportActionNotFound"] = "CarePractitionerReportActionNotFound";
    OperationResultCode["DashboardUserAlreadyConfirmed"] = "DashboardUserAlreadyConfirmed";
    OperationResultCode["DashboardUserTitleNotFound"] = "DashboardUserTitleNotFound";
    OperationResultCode["DashboardUserNotFound"] = "DashboardUserNotFound";
    OperationResultCode["InvalidConfirmationToken"] = "InvalidConfirmationToken";
    OperationResultCode["DashboardUserHasNotBeenInvited"] = "DashboardUserHasNotBeenInvited";
    OperationResultCode["DashboardUserAlreadyRegistered"] = "DashboardUserAlreadyRegistered";
    OperationResultCode["DashboardUserInviteAlreadyRevoked"] = "DashboardUserInviteAlreadyRevoked";
    OperationResultCode["OrpyxRoleNotFound"] = "OrpyxRoleNotFound";
    OperationResultCode["AtLeastOneRoleIsRequired"] = "AtLeastOneRoleIsRequired";
    OperationResultCode["OrpyxUserNotFound"] = "OrpyxUserNotFound";
    OperationResultCode["OrpyxUserRoleAlreadyAssigned"] = "OrpyxUserRoleAlreadyAssigned";
    OperationResultCode["OrpyxUserRoleNotFound"] = "OrpyxUserRoleNotFound";
    OperationResultCode["OrpyxUserRoleOwnedByAnotherUser"] = "OrpyxUserRoleOwnedByAnotherUser";
    OperationResultCode["OrpyxUserRoleAlreadyRevoked"] = "OrpyxUserRoleAlreadyRevoked";
    OperationResultCode["DashboardUserAlreadyDeleted"] = "DashboardUserAlreadyDeleted";
    OperationResultCode["ProductNotFound"] = "ProductNotFound";
    OperationResultCode["ProductHasSameInsole"] = "ProductHasSameInsole";
    OperationResultCode["ProductHasSameSideInsole"] = "ProductHasSameSideInsole";
    OperationResultCode["InsoleSerialNumberIsTaken"] = "InsoleSerialNumberIsTaken";
    OperationResultCode["ProductWithSerialNumberAlreadyExists"] = "ProductWithSerialNumberAlreadyExists";
    OperationResultCode["NothingToRevoke"] = "NothingToRevoke";
    OperationResultCode["OrpyxUserRolesHasDuplicates"] = "OrpyxUserRolesHasDuplicates";
    OperationResultCode["OrpyxUserAlreadyDeleted"] = "OrpyxUserAlreadyDeleted";
    OperationResultCode["OrpyxUserAlreadyConfirmed"] = "OrpyxUserAlreadyConfirmed";
    OperationResultCode["ProductNotContainsInsole"] = "ProductNotContainsInsole";
    OperationResultCode["AtLeastOneInsoleInProductRequired"] = "AtLeastOneInsoleInProductRequired";
    OperationResultCode["NullOrEmptyEmailIsNotAllowed"] = "NullOrEmptyEmailIsNotAllowed";
    OperationResultCode["PatientNotDeleted"] = "PatientNotDeleted";
    OperationResultCode["OrpyxUserNotDeleted"] = "OrpyxUserNotDeleted";
    OperationResultCode["OrganizationDeleted"] = "OrganizationDeleted";
    OperationResultCode["OrganizationNotDeleted"] = "OrganizationNotDeleted";
    OperationResultCode["DashboardUserNotDeleted"] = "DashboardUserNotDeleted";
    OperationResultCode["ActionRequiredAlertNotFound"] = "ActionRequiredAlertNotFound";
    OperationResultCode["WrongPlantarTemperatureLog"] = "WrongPlantarTemperatureLog";
    OperationResultCode["RemotePatientMonitoringProviderNotFound"] = "RemotePatientMonitoringProviderNotFound";
    OperationResultCode["RemotePatientMonitoringProviderExist"] = "RemotePatientMonitoringProviderExist";
    OperationResultCode["InsoleSnNotFound"] = "InsoleSnNotFound";
    OperationResultCode["InsoleSnIsInvalid"] = "InsoleSnIsInvalid";
    OperationResultCode["InsoleMismatch"] = "InsoleMismatch";
    OperationResultCode["ShoePodIdNotRegistered"] = "ShoePodIdNotRegistered";
    OperationResultCode["OrganizationChannelNotFound"] = "OrganizationChannelNotFound";
    OperationResultCode["PrimaryConcernRequired"] = "PrimaryConcernRequired";
    OperationResultCode["PrimaryConcernNotValidForAction"] = "PrimaryConcernNotValidForAction";
    OperationResultCode["SuggestedProviderActionsRequired"] = "SuggestedProviderActionsRequired";
    OperationResultCode["SuggestedActionNotValidForPrimaryConcern"] = "SuggestedActionNotValidForPrimaryConcern";
    OperationResultCode["FailedCreateAzureUser"] = "FailedCreateAzureUser";
    OperationResultCode["InvalidAzureB2CObjectId"] = "InvalidAzureB2CObjectId";
    OperationResultCode["InvalidInsertType"] = "InvalidInsertType";
    OperationResultCode["InvalidRpmVer"] = "InvalidRpmVer";
    OperationResultCode["RpmServiceProviderNotFound"] = "RpmServiceProviderNotFound";
    OperationResultCode["InvalidInsertSide"] = "InvalidInsertSide";
    OperationResultCode["ShoePodIdInsertIdMismatch"] = "ShoePodIdInsertIdMismatch";
    OperationResultCode["RpmFileFailedToParse"] = "RpmFileFailedToParse";
    OperationResultCode["RpmFileTimeStatusCorrupt"] = "RpmFileTimeStatusCorrupt";
    OperationResultCode["RpmOutdatedTimestamp"] = "RpmOutdatedTimestamp";
    OperationResultCode["HeartbeatInvalidVer"] = "HeartbeatInvalidVer";
    OperationResultCode["HeartbeatFileFailedToParse"] = "HeartbeatFileFailedToParse";
    OperationResultCode["DotDataFilesNoLongerSupported"] = "DotDataFilesNoLongerSupported";
    OperationResultCode["RpmTimestampBeforeReleaseDate"] = "RpmTimestampBeforeReleaseDate";
    OperationResultCode["InvalidNumberOfTemperatureSensors"] = "InvalidNumberOfTemperatureSensors";
    OperationResultCode["FileProcessedWithErrors"] = "FileProcessedWithErrors";
    OperationResultCode["RecordMissingTemperatureData"] = "RecordMissingTemperatureData";
    OperationResultCode["RecordMissingAlertData"] = "RecordMissingAlertData";
    OperationResultCode["RecordMissingStepCountData"] = "RecordMissingStepCountData";
    OperationResultCode["InvalidNumberOfPressureReadings"] = "InvalidNumberOfPressureReadings";
    OperationResultCode["RpmTimestampBeforePatientOnboardingDate"] = "RpmTimestampBeforePatientOnboardingDate";
    OperationResultCode["ScratchPadNoteUpsertFailure"] = "ScratchPadNoteUpsertFailure";
})(OperationResultCode || (OperationResultCode = {}));
export class OperationError {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null;
            this.code = _data["code"] !== undefined ? _data["code"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OperationError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        data["code"] = this.code !== undefined ? this.code : null;
        return data;
    }
}
export var ActionRequiredAlertTypeEnum;
(function (ActionRequiredAlertTypeEnum) {
    ActionRequiredAlertTypeEnum["DataReviewWith7Days"] = "DataReviewWith7Days";
    ActionRequiredAlertTypeEnum["PatientHasNotBeenWearingDeviceFor3Days"] = "PatientHasNotBeenWearingDeviceFor3Days";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForBigToe"] = "PatientTemperatureAlertForBigToe";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForHeel"] = "PatientTemperatureAlertForHeel";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta1"] = "PatientTemperatureAlertForMeta1";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta3"] = "PatientTemperatureAlertForMeta3";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta5"] = "PatientTemperatureAlertForMeta5";
    ActionRequiredAlertTypeEnum["SafePressureDropsBelow60Percent"] = "SafePressureDropsBelow60Percent";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForBigToeWithLeftFootIpsi"] = "PatientTemperatureAlertForBigToeWithLeftFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForHeelWithLeftFootIpsi"] = "PatientTemperatureAlertForHeelWithLeftFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta1WithLeftFootIpsi"] = "PatientTemperatureAlertForMeta1WithLeftFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta3WithLeftFootIpsi"] = "PatientTemperatureAlertForMeta3WithLeftFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta5WithLeftFootIpsi"] = "PatientTemperatureAlertForMeta5WithLeftFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForBigToeWithRightFootIpsi"] = "PatientTemperatureAlertForBigToeWithRightFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForHeelWithRightFootIpsi"] = "PatientTemperatureAlertForHeelWithRightFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta1WithRightFootIpsi"] = "PatientTemperatureAlertForMeta1WithRightFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta3WithRightFootIpsi"] = "PatientTemperatureAlertForMeta3WithRightFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta5WithRightFootIpsi"] = "PatientTemperatureAlertForMeta5WithRightFootIpsi";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForBigToeWithLeftFootContra"] = "PatientTemperatureAlertForBigToeWithLeftFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForHeelWithLeftFootContra"] = "PatientTemperatureAlertForHeelWithLeftFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta1WithLeftFootContra"] = "PatientTemperatureAlertForMeta1WithLeftFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta3WithLeftFootContra"] = "PatientTemperatureAlertForMeta3WithLeftFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta5WithLeftFootContra"] = "PatientTemperatureAlertForMeta5WithLeftFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForBigToeWithRightFootContra"] = "PatientTemperatureAlertForBigToeWithRightFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForHeelWithRightFootContra"] = "PatientTemperatureAlertForHeelWithRightFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta1WithRightFootContra"] = "PatientTemperatureAlertForMeta1WithRightFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta3WithRightFootContra"] = "PatientTemperatureAlertForMeta3WithRightFootContra";
    ActionRequiredAlertTypeEnum["PatientTemperatureAlertForMeta5WithRightFootContra"] = "PatientTemperatureAlertForMeta5WithRightFootContra";
})(ActionRequiredAlertTypeEnum || (ActionRequiredAlertTypeEnum = {}));
export class ActionRequiredAlertsEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.alertMessage = _data["alertMessage"] !== undefined ? _data["alertMessage"] : null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null;
            this.type = _data["type"] !== undefined ? _data["type"] : null;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRequiredAlertsEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["alertMessage"] = this.alertMessage !== undefined ? this.alertMessage : null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data;
    }
}
export class ListActionRequiredAlertsResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            if (Array.isArray(_data["entries"])) {
                this.entries = [];
                for (let item of _data["entries"])
                    this.entries.push(ActionRequiredAlertsEntry.fromJS(item));
            }
            else {
                this.entries = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListActionRequiredAlertsResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ActionRequiredAlertType {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.alertMessage = _data["alertMessage"] !== undefined ? _data["alertMessage"] : null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : null;
            this.type = _data["type"] !== undefined ? _data["type"] : null;
            this.displayPriority = _data["displayPriority"] !== undefined ? _data["displayPriority"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRequiredAlertType();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["alertMessage"] = this.alertMessage !== undefined ? this.alertMessage : null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null;
        data["type"] = this.type !== undefined ? this.type : null;
        data["displayPriority"] = this.displayPriority !== undefined ? this.displayPriority : null;
        return data;
    }
}
export class SuggestedActionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.actionOwner = _data["actionOwner"] !== undefined ? _data["actionOwner"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestedActionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["actionOwner"] = this.actionOwner !== undefined ? this.actionOwner : null;
        return data;
    }
}
export class PrimaryConcernDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            if (Array.isArray(_data["suggestedActions"])) {
                this.suggestedActions = [];
                for (let item of _data["suggestedActions"])
                    this.suggestedActions.push(SuggestedActionDto.fromJS(item));
            }
            else {
                this.suggestedActions = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryConcernDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        if (Array.isArray(this.suggestedActions)) {
            data["suggestedActions"] = [];
            for (let item of this.suggestedActions)
                data["suggestedActions"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class CarePractitionerActionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.url = _data["url"] !== undefined ? _data["url"] : null;
            this.hasReport = _data["hasReport"] !== undefined ? _data["hasReport"] : null;
            if (Array.isArray(_data["primaryConcerns"])) {
                this.primaryConcerns = [];
                for (let item of _data["primaryConcerns"])
                    this.primaryConcerns.push(PrimaryConcernDto.fromJS(item));
            }
            else {
                this.primaryConcerns = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CarePractitionerActionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["url"] = this.url !== undefined ? this.url : null;
        data["hasReport"] = this.hasReport !== undefined ? this.hasReport : null;
        if (Array.isArray(this.primaryConcerns)) {
            data["primaryConcerns"] = [];
            for (let item of this.primaryConcerns)
                data["primaryConcerns"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export var Foot;
(function (Foot) {
    Foot["LeftFoot"] = "LeftFoot";
    Foot["RightFoot"] = "RightFoot";
})(Foot || (Foot = {}));
export var ComparedTo;
(function (ComparedTo) {
    ComparedTo["Contralateral"] = "Contralateral";
    ComparedTo["Ipsilateral"] = "Ipsilateral";
})(ComparedTo || (ComparedTo = {}));
export var Sensor;
(function (Sensor) {
    Sensor["BigToe"] = "BigToe";
    Sensor["Meta1"] = "Meta1";
    Sensor["Meta3"] = "Meta3";
    Sensor["Meta5"] = "Meta5";
    Sensor["Heel"] = "Heel";
})(Sensor || (Sensor = {}));
export class TemperatureOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.foot = _data["foot"] !== undefined ? _data["foot"] : null;
            this.comparedTo = _data["comparedTo"] !== undefined ? _data["comparedTo"] : null;
            this.sensor = _data["sensor"] !== undefined ? _data["sensor"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["foot"] = this.foot !== undefined ? this.foot : null;
        data["comparedTo"] = this.comparedTo !== undefined ? this.comparedTo : null;
        data["sensor"] = this.sensor !== undefined ? this.sensor : null;
        return data;
    }
}
export class ActivityLogReportOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.timeZoneOffset = _data["timeZoneOffset"] !== undefined ? _data["timeZoneOffset"] : null;
            this.temperature = _data["temperature"] ? TemperatureOptions.fromJS(_data["temperature"]) : null;
            this.dateOverride = _data["dateOverride"] ? moment(_data["dateOverride"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogReportOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset !== undefined ? this.timeZoneOffset : null;
        data["temperature"] = this.temperature ? this.temperature.toJSON() : null;
        data["dateOverride"] = this.dateOverride ? this.dateOverride.toISOString() : null;
        return data;
    }
}
export class PostCareNoteModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.activityLogReportBuildingOptions = new ActivityLogReportOptions();
        }
    }
    init(_data) {
        if (_data) {
            this.trackingTime = _data["trackingTime"] !== undefined ? _data["trackingTime"] : null;
            this.manualTime = _data["manualTime"] !== undefined ? _data["manualTime"] : null;
            this.carePractitionerActionTypeId = _data["carePractitionerActionTypeId"] !== undefined ? _data["carePractitionerActionTypeId"] : null;
            this.primaryConcernTypeId = _data["primaryConcernTypeId"] !== undefined ? _data["primaryConcernTypeId"] : null;
            this.suggestedActionTypeId = _data["suggestedActionTypeId"] !== undefined ? _data["suggestedActionTypeId"] : null;
            this.noteText = _data["noteText"] !== undefined ? _data["noteText"] : null;
            if (Array.isArray(_data["actionRequiredAlertIds"])) {
                this.actionRequiredAlertIds = [];
                for (let item of _data["actionRequiredAlertIds"])
                    this.actionRequiredAlertIds.push(item);
            }
            else {
                this.actionRequiredAlertIds = null;
            }
            this.activityLogReportBuildingOptions = _data["activityLogReportBuildingOptions"] ? ActivityLogReportOptions.fromJS(_data["activityLogReportBuildingOptions"]) : new ActivityLogReportOptions();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostCareNoteModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["trackingTime"] = this.trackingTime !== undefined ? this.trackingTime : null;
        data["manualTime"] = this.manualTime !== undefined ? this.manualTime : null;
        data["carePractitionerActionTypeId"] = this.carePractitionerActionTypeId !== undefined ? this.carePractitionerActionTypeId : null;
        data["primaryConcernTypeId"] = this.primaryConcernTypeId !== undefined ? this.primaryConcernTypeId : null;
        data["suggestedActionTypeId"] = this.suggestedActionTypeId !== undefined ? this.suggestedActionTypeId : null;
        data["noteText"] = this.noteText !== undefined ? this.noteText : null;
        if (Array.isArray(this.actionRequiredAlertIds)) {
            data["actionRequiredAlertIds"] = [];
            for (let item of this.actionRequiredAlertIds)
                data["actionRequiredAlertIds"].push(item);
        }
        data["activityLogReportBuildingOptions"] = this.activityLogReportBuildingOptions ? this.activityLogReportBuildingOptions.toJSON() : null;
        return data;
    }
}
export class ListCareNotesResultEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.carePractitionerFullName = _data["carePractitionerFullName"] !== undefined ? _data["carePractitionerFullName"] : null;
            this.carePractitionerAction = _data["carePractitionerAction"] ? CarePractitionerActionDto.fromJS(_data["carePractitionerAction"]) : null;
            this.primaryConcernTypeId = _data["primaryConcernTypeId"] !== undefined ? _data["primaryConcernTypeId"] : null;
            this.primaryConcernName = _data["primaryConcernName"] !== undefined ? _data["primaryConcernName"] : null;
            this.suggestedActionTypeId = _data["suggestedActionTypeId"] !== undefined ? _data["suggestedActionTypeId"] : null;
            this.suggestedActionText = _data["suggestedActionText"] !== undefined ? _data["suggestedActionText"] : null;
            this.suggestedActionOwner = _data["suggestedActionOwner"] !== undefined ? _data["suggestedActionOwner"] : null;
            this.noteDate = _data["noteDate"] ? moment(_data["noteDate"].toString()) : null;
            this.noteText = _data["noteText"] !== undefined ? _data["noteText"] : null;
            this.trackingTime = _data["trackingTime"] !== undefined ? _data["trackingTime"] : null;
            this.manualTime = _data["manualTime"] !== undefined ? _data["manualTime"] : null;
            this.relatedReportName = _data["relatedReportName"] !== undefined ? _data["relatedReportName"] : null;
            this.rowMarker = _data["rowMarker"] !== undefined ? _data["rowMarker"] : null;
            if (Array.isArray(_data["actionRequiredAlerts"])) {
                this.actionRequiredAlerts = [];
                for (let item of _data["actionRequiredAlerts"])
                    this.actionRequiredAlerts.push(ActionRequiredAlertsEntry.fromJS(item));
            }
            else {
                this.actionRequiredAlerts = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListCareNotesResultEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["carePractitionerFullName"] = this.carePractitionerFullName !== undefined ? this.carePractitionerFullName : null;
        data["carePractitionerAction"] = this.carePractitionerAction ? this.carePractitionerAction.toJSON() : null;
        data["primaryConcernTypeId"] = this.primaryConcernTypeId !== undefined ? this.primaryConcernTypeId : null;
        data["primaryConcernName"] = this.primaryConcernName !== undefined ? this.primaryConcernName : null;
        data["suggestedActionTypeId"] = this.suggestedActionTypeId !== undefined ? this.suggestedActionTypeId : null;
        data["suggestedActionText"] = this.suggestedActionText !== undefined ? this.suggestedActionText : null;
        data["suggestedActionOwner"] = this.suggestedActionOwner !== undefined ? this.suggestedActionOwner : null;
        data["noteDate"] = this.noteDate ? this.noteDate.toISOString() : null;
        data["noteText"] = this.noteText !== undefined ? this.noteText : null;
        data["trackingTime"] = this.trackingTime !== undefined ? this.trackingTime : null;
        data["manualTime"] = this.manualTime !== undefined ? this.manualTime : null;
        data["relatedReportName"] = this.relatedReportName !== undefined ? this.relatedReportName : null;
        data["rowMarker"] = this.rowMarker !== undefined ? this.rowMarker : null;
        if (Array.isArray(this.actionRequiredAlerts)) {
            data["actionRequiredAlerts"] = [];
            for (let item of this.actionRequiredAlerts)
                data["actionRequiredAlerts"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class ListCareNotesResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["careNotes"])) {
                this.careNotes = [];
                for (let item of _data["careNotes"])
                    this.careNotes.push(ListCareNotesResultEntry.fromJS(item));
            }
            else {
                this.careNotes = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ListCareNotesResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careNotes)) {
            data["careNotes"] = [];
            for (let item of this.careNotes)
                data["careNotes"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class FileResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : null;
            this.content = _data["content"] !== undefined ? _data["content"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null;
        data["content"] = this.content !== undefined ? this.content : null;
        return data;
    }
}
export var UserAccountStatus;
(function (UserAccountStatus) {
    UserAccountStatus["NotActivated"] = "NotActivated";
    UserAccountStatus["Activated"] = "Activated";
    UserAccountStatus["Deactivated"] = "Deactivated";
})(UserAccountStatus || (UserAccountStatus = {}));
export class Address {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.street = _data["street"] !== undefined ? _data["street"] : null;
            this.state = _data["state"] !== undefined ? _data["state"] : null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null;
            this.city = _data["city"] !== undefined ? _data["city"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street !== undefined ? this.street : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        return data;
    }
}
export class OrganizationOutputDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null;
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.timeZoneOffset = _data["timeZoneOffset"] !== undefined ? _data["timeZoneOffset"] : null;
            this.organizationChannelId = _data["organizationChannelId"] !== undefined ? _data["organizationChannelId"] : null;
            this.organizationChannelName = _data["organizationChannelName"] !== undefined ? _data["organizationChannelName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOutputDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["address"] = this.address ? this.address.toJSON() : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["timeZoneOffset"] = this.timeZoneOffset !== undefined ? this.timeZoneOffset : null;
        data["organizationChannelId"] = this.organizationChannelId !== undefined ? this.organizationChannelId : null;
        data["organizationChannelName"] = this.organizationChannelName !== undefined ? this.organizationChannelName : null;
        return data;
    }
}
export class GetDashboardUserProfileResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dashboardUserId = _data["dashboardUserId"] !== undefined ? _data["dashboardUserId"] : null;
            this.email = _data["email"] !== undefined ? _data["email"] : null;
            this.title = _data["title"] !== undefined ? _data["title"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.status = _data["status"] !== undefined ? _data["status"] : null;
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : null;
            this.defaultOrganization = _data["defaultOrganization"] ? OrganizationOutputDto.fromJS(_data["defaultOrganization"]) : null;
            this.hasCustomerCarePermissions = _data["hasCustomerCarePermissions"] !== undefined ? _data["hasCustomerCarePermissions"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardUserProfileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dashboardUserId"] = this.dashboardUserId !== undefined ? this.dashboardUserId : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["defaultOrganization"] = this.defaultOrganization ? this.defaultOrganization.toJSON() : null;
        data["hasCustomerCarePermissions"] = this.hasCustomerCarePermissions !== undefined ? this.hasCustomerCarePermissions : null;
        return data;
    }
}
export class GetPatientReportsListEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : null;
            this.reportMonth = _data["reportMonth"] ? moment(_data["reportMonth"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientReportsListEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null;
        data["reportMonth"] = this.reportMonth ? this.reportMonth.toISOString() : null;
        return data;
    }
}
export class GetPatientReportsListResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nextMarker = _data["nextMarker"] !== undefined ? _data["nextMarker"] : null;
            if (Array.isArray(_data["reports"])) {
                this.reports = [];
                for (let item of _data["reports"])
                    this.reports.push(GetPatientReportsListEntry.fromJS(item));
            }
            else {
                this.reports = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientReportsListResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nextMarker"] = this.nextMarker !== undefined ? this.nextMarker : null;
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class OrganizationOutputDtoPagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(OrganizationOutputDto.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOutputDtoPagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null);
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class InsightImage {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.date = _data["date"] !== undefined ? _data["date"] : null;
            this.url = _data["url"] !== undefined ? _data["url"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InsightImage();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date !== undefined ? this.date : null;
        data["url"] = this.url !== undefined ? this.url : null;
        return data;
    }
}
export class PatientInsightsResponseModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (let item of _data["images"])
                    this.images.push(InsightImage.fromJS(item));
            }
            else {
                this.images = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInsightsResponseModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class GetScratchPadNoteResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : null;
            this.version = _data["version"] !== undefined ? _data["version"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetScratchPadNoteResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null;
        data["version"] = this.version !== undefined ? this.version : null;
        return data;
    }
}
export class UpsertScratchPadNoteModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            this.note = _data["note"] !== undefined ? _data["note"] : null;
            this.version = _data["version"] !== undefined ? _data["version"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertScratchPadNoteModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        data["note"] = this.note !== undefined ? this.note : null;
        data["version"] = this.version !== undefined ? this.version : null;
        return data;
    }
}
export class UpsertScratchPadNoteResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : null;
            this.version = _data["version"] !== undefined ? _data["version"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertScratchPadNoteResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null;
        data["version"] = this.version !== undefined ? this.version : null;
        return data;
    }
}
export class SensorStatisticsSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.avgActiveTimeSecs = _data["avgActiveTimeSecs"] !== undefined ? _data["avgActiveTimeSecs"] : null;
            this.avgAlertTimeSecs = _data["avgAlertTimeSecs"] !== undefined ? _data["avgAlertTimeSecs"] : null;
            this.avgAlerts = _data["avgAlerts"] !== undefined ? _data["avgAlerts"] : null;
            this.avgPercentTimeInSafePressureZone = _data["avgPercentTimeInSafePressureZone"] !== undefined ? _data["avgPercentTimeInSafePressureZone"] : null;
            this.avgDailyUse = _data["avgDailyUse"] !== undefined ? _data["avgDailyUse"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SensorStatisticsSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["avgActiveTimeSecs"] = this.avgActiveTimeSecs !== undefined ? this.avgActiveTimeSecs : null;
        data["avgAlertTimeSecs"] = this.avgAlertTimeSecs !== undefined ? this.avgAlertTimeSecs : null;
        data["avgAlerts"] = this.avgAlerts !== undefined ? this.avgAlerts : null;
        data["avgPercentTimeInSafePressureZone"] = this.avgPercentTimeInSafePressureZone !== undefined ? this.avgPercentTimeInSafePressureZone : null;
        data["avgDailyUse"] = this.avgDailyUse !== undefined ? this.avgDailyUse : null;
        return data;
    }
}
export class FootRegionAlerts {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : null;
            this.heel = _data["heel"] !== undefined ? _data["heel"] : null;
            this.midfoot = _data["midfoot"] !== undefined ? _data["midfoot"] : null;
            this.innerMetas = _data["innerMetas"] !== undefined ? _data["innerMetas"] : null;
            this.outerMetas = _data["outerMetas"] !== undefined ? _data["outerMetas"] : null;
            this.innerToes = _data["innerToes"] !== undefined ? _data["innerToes"] : null;
            this.outerToes = _data["outerToes"] !== undefined ? _data["outerToes"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FootRegionAlerts();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : null;
        data["heel"] = this.heel !== undefined ? this.heel : null;
        data["midfoot"] = this.midfoot !== undefined ? this.midfoot : null;
        data["innerMetas"] = this.innerMetas !== undefined ? this.innerMetas : null;
        data["outerMetas"] = this.outerMetas !== undefined ? this.outerMetas : null;
        data["innerToes"] = this.innerToes !== undefined ? this.innerToes : null;
        data["outerToes"] = this.outerToes !== undefined ? this.outerToes : null;
        return data;
    }
}
export class SensorStatistics {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.activeDurationSecs = _data["activeDurationSecs"] !== undefined ? _data["activeDurationSecs"] : null;
            this.alerts = _data["alerts"] !== undefined ? _data["alerts"] : null;
            this.alertDurationSecs = _data["alertDurationSecs"] !== undefined ? _data["alertDurationSecs"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SensorStatistics();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["activeDurationSecs"] = this.activeDurationSecs !== undefined ? this.activeDurationSecs : null;
        data["alerts"] = this.alerts !== undefined ? this.alerts : null;
        data["alertDurationSecs"] = this.alertDurationSecs !== undefined ? this.alertDurationSecs : null;
        return data;
    }
}
export class FootRegionStatistics {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.heel = _data["heel"] ? SensorStatistics.fromJS(_data["heel"]) : null;
            this.midfoot = _data["midfoot"] ? SensorStatistics.fromJS(_data["midfoot"]) : null;
            this.innerMetas = _data["innerMetas"] ? SensorStatistics.fromJS(_data["innerMetas"]) : null;
            this.outerMetas = _data["outerMetas"] ? SensorStatistics.fromJS(_data["outerMetas"]) : null;
            this.innerToes = _data["innerToes"] ? SensorStatistics.fromJS(_data["innerToes"]) : null;
            this.outerToes = _data["outerToes"] ? SensorStatistics.fromJS(_data["outerToes"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FootRegionStatistics();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["heel"] = this.heel ? this.heel.toJSON() : null;
        data["midfoot"] = this.midfoot ? this.midfoot.toJSON() : null;
        data["innerMetas"] = this.innerMetas ? this.innerMetas.toJSON() : null;
        data["outerMetas"] = this.outerMetas ? this.outerMetas.toJSON() : null;
        data["innerToes"] = this.innerToes ? this.innerToes.toJSON() : null;
        data["outerToes"] = this.outerToes ? this.outerToes.toJSON() : null;
        return data;
    }
}
export class PatientStatisticsSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.overall = _data["overall"] ? SensorStatistics.fromJS(_data["overall"]) : null;
            this.leftFoot = _data["leftFoot"] ? FootRegionStatistics.fromJS(_data["leftFoot"]) : null;
            this.rightFoot = _data["rightFoot"] ? FootRegionStatistics.fromJS(_data["rightFoot"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatisticsSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["overall"] = this.overall ? this.overall.toJSON() : null;
        data["leftFoot"] = this.leftFoot ? this.leftFoot.toJSON() : null;
        data["rightFoot"] = this.rightFoot ? this.rightFoot.toJSON() : null;
        return data;
    }
}
export class DailyPatientSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateTimeToDay = _data["dateTimeToDay"] ? moment(_data["dateTimeToDay"].toString()) : null;
            this.summary = _data["summary"] ? PatientStatisticsSummary.fromJS(_data["summary"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DailyPatientSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateTimeToDay"] = this.dateTimeToDay ? this.dateTimeToDay.toISOString() : null;
        data["summary"] = this.summary ? this.summary.toJSON() : null;
        return data;
    }
}
export class PatientOverallSummaryMonth {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.overallAverages = _data["overallAverages"] ? SensorStatisticsSummary.fromJS(_data["overallAverages"]) : null;
            this.leftFootRegionAlerts = _data["leftFootRegionAlerts"] ? FootRegionAlerts.fromJS(_data["leftFootRegionAlerts"]) : null;
            this.rightFootRegionAlerts = _data["rightFootRegionAlerts"] ? FootRegionAlerts.fromJS(_data["rightFootRegionAlerts"]) : null;
            if (Array.isArray(_data["dailySummary"])) {
                this.dailySummary = [];
                for (let item of _data["dailySummary"])
                    this.dailySummary.push(DailyPatientSummary.fromJS(item));
            }
            else {
                this.dailySummary = null;
            }
            this.month = _data["month"] ? moment(_data["month"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOverallSummaryMonth();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["overallAverages"] = this.overallAverages ? this.overallAverages.toJSON() : null;
        data["leftFootRegionAlerts"] = this.leftFootRegionAlerts ? this.leftFootRegionAlerts.toJSON() : null;
        data["rightFootRegionAlerts"] = this.rightFootRegionAlerts ? this.rightFootRegionAlerts.toJSON() : null;
        if (Array.isArray(this.dailySummary)) {
            data["dailySummary"] = [];
            for (let item of this.dailySummary)
                data["dailySummary"].push(item ? item.toJSON() : null);
        }
        data["month"] = this.month ? this.month.toISOString() : null;
        return data;
    }
}
export class PatientOverallSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            if (Array.isArray(_data["months"])) {
                this.months = [];
                for (let item of _data["months"])
                    this.months.push(PatientOverallSummaryMonth.fromJS(item));
            }
            else {
                this.months = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOverallSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export class PatientStepCountsEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStepCountsEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : null;
        data["date"] = this.date ? this.date.toISOString() : null;
        return data;
    }
}
export class PatientStepCountsSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["count"])) {
                this.count = [];
                for (let item of _data["count"])
                    this.count.push(PatientStepCountsEntry.fromJS(item));
            }
            else {
                this.count = null;
            }
            this.averageSteps = _data["averageSteps"] !== undefined ? _data["averageSteps"] : null;
            this.month = _data["month"] ? moment(_data["month"].toString()) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStepCountsSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.count)) {
            data["count"] = [];
            for (let item of this.count)
                data["count"].push(item ? item.toJSON() : null);
        }
        data["averageSteps"] = this.averageSteps !== undefined ? this.averageSteps : null;
        data["month"] = this.month ? this.month.toISOString() : null;
        return data;
    }
}
export class PlantarTemperatureResultComparison {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ipsi = _data["ipsi"] !== undefined ? _data["ipsi"] : null;
            this.contra = _data["contra"] !== undefined ? _data["contra"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlantarTemperatureResultComparison();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ipsi"] = this.ipsi !== undefined ? this.ipsi : null;
        data["contra"] = this.contra !== undefined ? this.contra : null;
        return data;
    }
}
export class PlantarTemperatureResultRegion {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.bigToe = _data["bigToe"] ? PlantarTemperatureResultComparison.fromJS(_data["bigToe"]) : null;
            this.meta1 = _data["meta1"] ? PlantarTemperatureResultComparison.fromJS(_data["meta1"]) : null;
            this.meta3 = _data["meta3"] ? PlantarTemperatureResultComparison.fromJS(_data["meta3"]) : null;
            this.meta5 = _data["meta5"] ? PlantarTemperatureResultComparison.fromJS(_data["meta5"]) : null;
            this.heel = _data["heel"] ? PlantarTemperatureResultComparison.fromJS(_data["heel"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PlantarTemperatureResultRegion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["bigToe"] = this.bigToe ? this.bigToe.toJSON() : null;
        data["meta1"] = this.meta1 ? this.meta1.toJSON() : null;
        data["meta3"] = this.meta3 ? this.meta3.toJSON() : null;
        data["meta5"] = this.meta5 ? this.meta5.toJSON() : null;
        data["heel"] = this.heel ? this.heel.toJSON() : null;
        return data;
    }
}
export class DailyTemperatureResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dateTimeToDay = _data["dateTimeToDay"] ? moment(_data["dateTimeToDay"].toString()) : null;
            this.rightFoot = _data["rightFoot"] ? PlantarTemperatureResultRegion.fromJS(_data["rightFoot"]) : null;
            this.leftFoot = _data["leftFoot"] ? PlantarTemperatureResultRegion.fromJS(_data["leftFoot"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DailyTemperatureResultModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["dateTimeToDay"] = this.dateTimeToDay ? this.dateTimeToDay.toISOString() : null;
        data["rightFoot"] = this.rightFoot ? this.rightFoot.toJSON() : null;
        data["leftFoot"] = this.leftFoot ? this.leftFoot.toJSON() : null;
        return data;
    }
}
export class PatientTemperatureResultModel {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            if (Array.isArray(_data["dailySummary"])) {
                this.dailySummary = [];
                for (let item of _data["dailySummary"])
                    this.dailySummary.push(DailyTemperatureResultModel.fromJS(item));
            }
            else {
                this.dailySummary = null;
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTemperatureResultModel();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        if (Array.isArray(this.dailySummary)) {
            data["dailySummary"] = [];
            for (let item of this.dailySummary)
                data["dailySummary"].push(item ? item.toJSON() : null);
        }
        return data;
    }
}
export var PatientFilterType;
(function (PatientFilterType) {
    PatientFilterType["Active"] = "Active";
    PatientFilterType["NewPatients"] = "NewPatients";
    PatientFilterType["InactivePatients"] = "InactivePatients";
    PatientFilterType["GlobalSearch"] = "GlobalSearch";
})(PatientFilterType || (PatientFilterType = {}));
export var PatientFilterBy;
(function (PatientFilterBy) {
    PatientFilterBy["Name"] = "Name";
    PatientFilterBy["PatientId"] = "PatientId";
    PatientFilterBy["InsoleSerialNumbers"] = "InsoleSerialNumbers";
})(PatientFilterBy || (PatientFilterBy = {}));
export var GetPatientsListPropertyOrderBy;
(function (GetPatientsListPropertyOrderBy) {
    GetPatientsListPropertyOrderBy["FirstName"] = "FirstName";
    GetPatientsListPropertyOrderBy["LastName"] = "LastName";
    GetPatientsListPropertyOrderBy["AllowMarketingContact"] = "AllowMarketingContact";
    GetPatientsListPropertyOrderBy["ClientPatientIdentifier"] = "ClientPatientIdentifier";
    GetPatientsListPropertyOrderBy["DateOfPatientAuthorization"] = "DateOfPatientAuthorization";
    GetPatientsListPropertyOrderBy["LeftInsoleSerialNumber"] = "LeftInsoleSerialNumber";
    GetPatientsListPropertyOrderBy["RightInsoleSerialNumber"] = "RightInsoleSerialNumber";
    GetPatientsListPropertyOrderBy["LastReviewDate"] = "LastReviewDate";
    GetPatientsListPropertyOrderBy["Status"] = "Status";
    GetPatientsListPropertyOrderBy["LastStatusUpdatedAt"] = "LastStatusUpdatedAt";
})(GetPatientsListPropertyOrderBy || (GetPatientsListPropertyOrderBy = {}));
/** Statuses a caller may float to the top of the Inactive list. Values match            PatientStatusType ids, so the api value is passed straight through as PriorityStatusId. */
export var PatientPriorityStatus;
(function (PatientPriorityStatus) {
    PatientPriorityStatus["Paused"] = "Paused";
    PatientPriorityStatus["Discontinued"] = "Discontinued";
})(PatientPriorityStatus || (PatientPriorityStatus = {}));
export class PatientProductEntry {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.leftInsoleSerialNumber = _data["leftInsoleSerialNumber"] !== undefined ? _data["leftInsoleSerialNumber"] : null;
            this.rightInsoleSerialNumber = _data["rightInsoleSerialNumber"] !== undefined ? _data["rightInsoleSerialNumber"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatientProductEntry();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["leftInsoleSerialNumber"] = this.leftInsoleSerialNumber !== undefined ? this.leftInsoleSerialNumber : null;
        data["rightInsoleSerialNumber"] = this.rightInsoleSerialNumber !== undefined ? this.rightInsoleSerialNumber : null;
        return data;
    }
}
export class GetPatientsListResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.inactive = _data["inactive"] !== undefined ? _data["inactive"] : null;
            this.allowMarketingContact = _data["allowMarketingContact"] !== undefined ? _data["allowMarketingContact"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.lastStatusUpdatedAt = _data["lastStatusUpdatedAt"] ? moment(_data["lastStatusUpdatedAt"].toString()) : null;
            this.allowAccessStartDate = _data["allowAccessStartDate"] ? moment(_data["allowAccessStartDate"].toString()) : null;
            this.allowAccessEndDate = _data["allowAccessEndDate"] ? moment(_data["allowAccessEndDate"].toString()) : null;
            this.lastReviewDate = _data["lastReviewDate"] ? moment(_data["lastReviewDate"].toString()) : null;
            this.daysSinceLastReview = _data["daysSinceLastReview"] !== undefined ? _data["daysSinceLastReview"] : null;
            this.lastDataUploadDate = _data["lastDataUploadDate"] ? moment(_data["lastDataUploadDate"].toString()) : null;
            this.clientPatientIdentifier = _data["clientPatientIdentifier"] !== undefined ? _data["clientPatientIdentifier"] : null;
            this.contactPhoneNumber = _data["contactPhoneNumber"] !== undefined ? _data["contactPhoneNumber"] : null;
            this.product = _data["product"] ? PatientProductEntry.fromJS(_data["product"]) : null;
            if (Array.isArray(_data["actionRequiredAlerts"])) {
                this.actionRequiredAlerts = [];
                for (let item of _data["actionRequiredAlerts"])
                    this.actionRequiredAlerts.push(ActionRequiredAlertsEntry.fromJS(item));
            }
            else {
                this.actionRequiredAlerts = null;
            }
            this.organization = _data["organization"] ? OrganizationOutputDto.fromJS(_data["organization"]) : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientsListResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["inactive"] = this.inactive !== undefined ? this.inactive : null;
        data["allowMarketingContact"] = this.allowMarketingContact !== undefined ? this.allowMarketingContact : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["lastStatusUpdatedAt"] = this.lastStatusUpdatedAt ? this.lastStatusUpdatedAt.toISOString() : null;
        data["allowAccessStartDate"] = this.allowAccessStartDate ? this.allowAccessStartDate.toISOString() : null;
        data["allowAccessEndDate"] = this.allowAccessEndDate ? this.allowAccessEndDate.toISOString() : null;
        data["lastReviewDate"] = this.lastReviewDate ? this.lastReviewDate.toISOString() : null;
        data["daysSinceLastReview"] = this.daysSinceLastReview !== undefined ? this.daysSinceLastReview : null;
        data["lastDataUploadDate"] = this.lastDataUploadDate ? this.lastDataUploadDate.toISOString() : null;
        data["clientPatientIdentifier"] = this.clientPatientIdentifier !== undefined ? this.clientPatientIdentifier : null;
        data["contactPhoneNumber"] = this.contactPhoneNumber !== undefined ? this.contactPhoneNumber : null;
        data["product"] = this.product ? this.product.toJSON() : null;
        if (Array.isArray(this.actionRequiredAlerts)) {
            data["actionRequiredAlerts"] = [];
            for (let item of this.actionRequiredAlerts)
                data["actionRequiredAlerts"].push(item ? item.toJSON() : null);
        }
        data["organization"] = this.organization ? this.organization.toJSON() : null;
        return data;
    }
}
export class GetPatientsListResponsePagingResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(GetPatientsListResponse.fromJS(item));
            }
            else {
                this.items = null;
            }
            this.total = _data["total"] !== undefined ? _data["total"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientsListResponsePagingResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null);
        }
        data["total"] = this.total !== undefined ? this.total : null;
        return data;
    }
}
export class GetPatientInformationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.patientId = _data["patientId"] !== undefined ? _data["patientId"] : null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null;
            this.clientPatientIdentifier = _data["clientPatientIdentifier"] !== undefined ? _data["clientPatientIdentifier"] : null;
            this.statusId = _data["statusId"] !== undefined ? _data["statusId"] : null;
            this.statusName = _data["statusName"] !== undefined ? _data["statusName"] : null;
            this.lastStatusUpdatedAt = _data["lastStatusUpdatedAt"] ? moment(_data["lastStatusUpdatedAt"].toString()) : null;
            this.dataCurrentAsOf = _data["dataCurrentAsOf"] ? moment(_data["dataCurrentAsOf"].toString()) : null;
            this.allowAccessStartDate = _data["allowAccessStartDate"] ? moment(_data["allowAccessStartDate"].toString()) : null;
            this.contactPhoneNumber = _data["contactPhoneNumber"] !== undefined ? _data["contactPhoneNumber"] : null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : null;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientInformationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId !== undefined ? this.patientId : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["clientPatientIdentifier"] = this.clientPatientIdentifier !== undefined ? this.clientPatientIdentifier : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["statusName"] = this.statusName !== undefined ? this.statusName : null;
        data["lastStatusUpdatedAt"] = this.lastStatusUpdatedAt ? this.lastStatusUpdatedAt.toISOString() : null;
        data["dataCurrentAsOf"] = this.dataCurrentAsOf ? this.dataCurrentAsOf.toISOString() : null;
        data["allowAccessStartDate"] = this.allowAccessStartDate ? this.allowAccessStartDate.toISOString() : null;
        data["contactPhoneNumber"] = this.contactPhoneNumber !== undefined ? this.contactPhoneNumber : null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : null;
        return data;
    }
}
export var DashboardUserType;
(function (DashboardUserType) {
    DashboardUserType["DashboardUser"] = "DashboardUser";
})(DashboardUserType || (DashboardUserType = {}));
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
